import { Loader2 } from "lucide-react";

const LoadingOverlay = () => (
  <div className="flex h-full items-center justify-center p-4">
    <div className="text-sm text-muted-foreground">
      <Loader2 className="h-6 w-6 animate-spin" strokeWidth={1.5} />
    </div>
  </div>
);

export default LoadingOverlay;
